if (!customElements.get('mega-menu-catalog')) {
  class MegaMenuCatalog extends HTMLElement {
    constructor() {
      super();
      this.activeFilters = [];
      this.currentKey = '';
    }

    connectedCallback() {
      this.primaryButtons = this.querySelectorAll('[data-mmc-panel]');
      this.secondaryPanels = this.querySelectorAll('[data-mmc-secondary-panel]');
      this.collectionLinks = this.querySelectorAll('[data-collection-key]');
      this.productPanels = this.querySelectorAll('[data-mmc-products-panel]');
      this.filterGroups = this.querySelectorAll('[data-mmc-filter-group]');
      this.viewMoreEl = this.querySelector('[data-mmc-view-more]');

      this.ensureInitialPanel();
      this.bindEvents();
    }

    ensureInitialPanel() {
      let activePanel = this.querySelector('[data-mmc-products-panel].is-active');

      if (!activePanel && this.productPanels.length) {
        activePanel = this.productPanels[0];
        activePanel.classList.add('is-active');
      }

      if (!activePanel) return;

      const key = activePanel.dataset.collectionKey;
      if (!key) return;

      this.currentKey = key;
      const matchingLink = Array.from(this.collectionLinks).find(
        (link) => link.dataset.collectionKey === key
      );

      if (matchingLink) {
        matchingLink.classList.add('is-active');
        matchingLink.setAttribute('aria-current', 'true');
      }

      if (this.viewMoreEl) {
        const collectionUrl = activePanel.dataset.collectionUrl || matchingLink?.dataset.collectionUrl || '';
        this.viewMoreEl.href = collectionUrl || '#';
        this.viewMoreEl.hidden = !collectionUrl;
      }

      this.hideFilterGroups();
      this.resetFilters();
    }

    bindEvents() {
      this.primaryButtons.forEach((button) => {
        button.addEventListener('mouseenter', () => this.selectPrimary(button));
      });

      this.collectionLinks.forEach((link) => {
        link.addEventListener('mouseenter', () => this.selectCollection(link));
      });

      this.querySelectorAll('[data-filter-tag]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleFilter(button);
        });
      });
    }

    hideFilterGroups() {
      this.filterGroups.forEach((group) => {
        group.hidden = true;
      });
    }

    syncFilterGroup(panelKey) {
      if (!panelKey) {
        this.hideFilterGroups();
        return;
      }

      this.filterGroups.forEach((group) => {
        group.hidden = group.dataset.mmcFilterGroup !== panelKey;
      });
    }

    selectPrimary(button) {
      const panelId = button.dataset.mmcPanel;
      this.primaryButtons.forEach((btn) => {
        const isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
      this.secondaryPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === panelId);
      });

      const activeSecondary = this.querySelector(`#${CSS.escape(panelId)}`);
      const firstCollection = activeSecondary?.querySelector('[data-collection-key]');
      if (firstCollection) {
        this.selectCollection(firstCollection, true);
      }
    }

    selectCollection(link, force = false) {
      const key = link.dataset.collectionKey;
      if (!key) return;

      if (!force && key === this.currentKey) {
        this.syncFilterGroup(key);
        return;
      }

      this.currentKey = key;
      this.collectionLinks.forEach((el) => {
        el.classList.toggle('is-active', el === link);
        el.toggleAttribute('aria-current', el === link);
      });

      const activePanel = Array.from(this.productPanels).find(
        (panel) => panel.dataset.collectionKey === key
      );

      this.productPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel === activePanel);
      });

      const collectionUrl = link.dataset.collectionUrl || link.getAttribute('href') || '';
      if (this.viewMoreEl) {
        this.viewMoreEl.href = collectionUrl;
        this.viewMoreEl.hidden = !collectionUrl;
      }

      this.syncFilterGroup(key);
      this.resetFilters();
    }

    getActivePanel() {
      return this.querySelector('[data-mmc-products-panel].is-active');
    }

    resetFilters() {
      this.activeFilters = [];
      this.querySelectorAll('[data-filter-tag]').forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
      this.applyFilters();
    }

    toggleFilter(button) {
      const tag = button.dataset.filterTag;
      if (!tag) return;

      const index = this.activeFilters.indexOf(tag);
      if (index >= 0) {
        this.activeFilters.splice(index, 1);
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      } else {
        this.activeFilters.push(tag);
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
      }

      this.applyFilters();
    }

    applyFilters() {
      const panel = this.getActivePanel();
      if (!panel) return;

      panel.querySelectorAll('.mega-menu-catalog__product').forEach((item) => {
        if (!this.activeFilters.length) {
          item.classList.remove('is-hidden');
          return;
        }
        const tags = (item.dataset.productTags || '')
          .split(',')
          .map((t) => t.trim())
          .filter(Boolean);
        const match = this.activeFilters.every((filter) => tags.includes(filter.trim()));
        item.classList.toggle('is-hidden', !match);
      });
    }
  }

  customElements.define('mega-menu-catalog', MegaMenuCatalog);
}
